import { addPkgs /*, addLibsMap, loadLibPkgFn , applyAGGridLicenseKey */ } from './base'

addPkgs({
  'panwds': () => import(/* webpackPreload: true */ './panwds'), // by default for now
  'material-ui': () => import(/* webpackPreload: true */ './material-ui'), // by default for now
  // 'highcharts': () => import(/* webpackChunkName: "hc" */ './highcharts'),
  // 'ag-grid': () => import(/* webpackChunkName: "ag" */ './ag-grid').then(applyAGGridLicenseKey),
})

// addLibsMap({
//   'ag-grid': loadLibPkgFn('ag-grid'),
//   'ag-grid-community': loadLibPkgFn('ag-grid', 'agGridCommunity'),
//   'ag-grid-enterprise': loadLibPkgFn('ag-grid', 'agGridEnterprise'),
//   'ag-grid-react': loadLibPkgFn('ag-grid', 'agGridReact'),
//   'highcharts': loadLibPkgFn('highcharts', 'Highcharts'),
//   'highcharts-react-official': loadLibPkgFn('highcharts', 'HighchartsReact'),
// })

export * from './base'
export { default } from './base'
